class LanguageService extends BaseService
	@register()
	@inject '$translate',
		'$q'
		'PublicRepository'
		'BASE_LANGUAGE'
		'DISPLAY_LANGUAGE_KEY'
		'localStorageService'
		'UserInformation'
		'MessageTerminal'

	initialize: ->
		@languages = null

	setLanguages: (languages) ->
		@languages = languages
		@setDisplayLanguage(@getDisplayLanguage())

	getLanguages: ->
		return @languages

	getDisplayLanguage: ->
		displayLanguage = @localStorageService.get(@DISPLAY_LANGUAGE_KEY)

		if !displayLanguage?
			return @getSystemLanguage()

		return @getByIso(displayLanguage)

	getSystemLanguage: ->
		systemLanguage = @getByIso(@UserInformation.getMasterUser().language.toLowerCase())

		if !systemLanguage?
			return @getBaseLanguage()

		return systemLanguage

	setDisplayLanguage: (languageData) ->
		language = languageData.language.toLowerCase()
		@localStorageService.set(@DISPLAY_LANGUAGE_KEY, language)
		@$translate.use(language)

		@MessageTerminal.publish(@MessageTerminal.events.DISPLAY_LANGUAGE, languageData)

	getBaseLanguage: ->
		return @getByIso(@BASE_LANGUAGE.language)

	getByIso: (iso) ->
		return _.find(@languages, {language: iso})
